import React from 'react';

export const TelText = () => {
  return (
    <p>
      Розміщують у легкодоступних і помітних місцях. При пожежі потрібно зателефонувати 101 і повідомити адресу об’єкта;
      місце виникнення пожежі; своє прізвище.
    </p>
  );
};
